import {ApplicationInsights, DistributedTracingModes} from '@microsoft/applicationinsights-web';
import {ReactPlugin} from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory({ basename: '' });
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: "InstrumentationKey=3d998ffc-21e8-4d65-bdea-401c9da30588;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=0f05c75a-242e-47e2-acf8-d8800e930ecd",
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
    enableAutoRouteTracking: true,
    disableAjaxTracking: false,
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: false,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    distributedTracingMode: DistributedTracingModes.AI,
    disableCorrelationHeaders: true,
  }
});
appInsights.loadAppInsights();

appInsights.addTelemetryInitializer((env) => {

    env.tags = env.tags || [];
    // eslint-disable-next-line no-undef
    env.tags["ai.cloud.role"] = process.env.REACT_APP_APPINSIGHTS_ROLENAME;
    env.tags["ai.user.authUserId"] = appInsights.context.user.authenticatedId;
    env.tags["ai.user.accountId"] = appInsights.context.user.accountId;
});

export { reactPlugin, appInsights };